module.exports = "<h3>\n  Thank you for subscribing! Will redirect you to home page...\n</h3>\n"